import de from "./de.js";

export const TEAM_LOCALES = ["de"];
export const DEFAULT_TEAM_LOCALE = "de";

const catalogs = { de };

export const createTranslator = (locale) => {
  const messages = catalogs[locale] || catalogs.de;
  return (key, vars) => {
    let str = messages[key] ?? key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        str = str.replace(new RegExp(`\\{\\{${k}\\}\\}`, "g"), String(v ?? ""));
      });
    }
    return str;
  };
};

export const getDateLocale = () => "de-DE";

export const getNumberLocale = () => "de-DE";
